/**
 * 权限操作处理 Hook
 */
import { useCallback } from "react";

export interface UsePermissionHandlersProps {
  handleCreate: (values: any) => Promise<boolean>;
  handleEdit: (values: any) => Promise<boolean>;
  handleDelete: (id: string) => Promise<boolean>;
  openEditModal: (permission: any) => void;
  loadPermissionTree: () => void;
  clearSelection: () => void;
  reloadPermissionDetails: (id: string) => Promise<void>;
  selectedOperation: any;
}

export interface UsePermissionHandlersReturn {
  handleCreateWrapper: (values: any) => Promise<boolean>;
  handleEditWrapper: (values: any) => Promise<boolean>;
  handleEditPermission: (permission: any) => void;
  handleDeletePermissionClick: (permission: any) => Promise<boolean>;
}

/**
 * 权限操作处理 Hook
 */
export const usePermissionHandlers = ({
  handleCreate,
  handleEdit,
  handleDelete,
  openEditModal,
  loadPermissionTree,
  clearSelection,
  reloadPermissionDetails,
  selectedOperation,
}: UsePermissionHandlersProps): UsePermissionHandlersReturn => {
  // 包装创建权限处理函数
  const handleCreateWrapper = useCallback(
    async (values: any) => {
      const result = await handleCreate(values);
      if (result) {
        // 重新加载权限树
        loadPermissionTree();
      }
      return result;
    },
    [handleCreate, loadPermissionTree]
  );

  // 包装编辑权限处理函数
  const handleEditWrapper = useCallback(
    async (values: any) => {
      const result = await handleEdit(values);
      if (result) {
        // 重新加载权限树
        loadPermissionTree();

        // 如果当前有选中的操作，重新加载其详情
        if (selectedOperation) {
          console.log("编辑成功后重新加载操作详情:", selectedOperation.id);
          await reloadPermissionDetails(selectedOperation.id);
        }
      }
      return result;
    },
    [handleEdit, loadPermissionTree, selectedOperation, reloadPermissionDetails]
  );

  // 处理编辑权限
  const handleEditPermission = useCallback(
    (permission: any) => {
      openEditModal(permission);
    },
    [openEditModal]
  );

  // 处理删除权限
  const handleDeletePermissionClick = useCallback(
    async (permission: any) => {
      const result = await handleDelete(permission.id);
      if (result) {
        // 重新加载权限树
        loadPermissionTree();
        // 清空选中状态
        clearSelection();
      }
      return result;
    },
    [handleDelete, loadPermissionTree, clearSelection]
  );

  return {
    handleCreateWrapper,
    handleEditWrapper,
    handleEditPermission,
    handleDeletePermissionClick,
  };
};

